import {SecureService} from "@/services/superclasses/secure-service";
import {Host} from "@/interfaces/host";

const api = window.contextPath + '/rest/hosts';

export class HostSecureService extends SecureService {

    public loadByMember = async (module?: Array<number>): Promise<Host[]> => {
        return this.data(await this.get<Host[]>(api + "/by-member",
            {
                params: {
                    module
                }
            }))
    }
}

export const hostSecureService = new HostSecureService()